const TYPES = {
  SeoService: Symbol.for('SeoService'),
};

export { TYPES };
